import "./style.css";
import {
  parseEngineInitParams,
  fontStacks,
  lightColors,
  darkColors,
} from "@bennara/shared";
import { Engine } from "./Engine";

// Inject shared font variables for consistency with mobile
const fontStyle = document.createElement("style");
fontStyle.textContent = `:root { --font-sans: ${fontStacks.sans}; --font-mono: ${fontStacks.mono}; }`;
document.head.appendChild(fontStyle);

const appRoot = document.querySelector<HTMLDivElement>("#app");
if (!appRoot) {
  throw new Error("App root element #app not found");
}

appRoot.innerHTML = "";

const init = parseEngineInitParams(new URLSearchParams(window.location.search));

window.theme = init.theme;
window.colors = init.theme === "light" ? lightColors : darkColors;

const app = new Engine(appRoot, init);

// Expose for debugging / cleanup if needed
if (typeof window !== "undefined") {
  (window as unknown as { __bennaraEngine?: Engine }).__bennaraEngine = app;
}
